<template>
  <div id="app" >
    <div style="display: flex;align-items: center">
      <van-nav-bar
        v-if='$route.meta.title'
        :title="$route.meta.title"
        left-text="返回"
        left-arrow
        style="flex: 1"
        @click-left="clickLeft"/>
      <div style="display: flex;flex-direction: column;align-items: center"
           v-if='$route.meta.title'>
        <img src="./assets/logo3.png" v-if='!$route.meta.logo3' style="width: 62px;height: 30px;">
        <p v-if='$route.meta.isHome' style="color: #1989fa;font-size: 16px;margin-right: 10px"
           @click="clickHome">{{ $route.meta.homeTitle }}</p>
      </div>
    </div>
    <div style="display: flex;height: 1px;width: 100%;background: #efefef"
         v-if='$route.meta.title'>
    </div>

    <router-view/>
    <img  v-if='!$route.meta.logo2' src="./assets/logo2.png" style="width: 120px;height: 15px;">
    <van-tabbar
      v-if='$route.meta.showTab'
      v-model="active"
      active-color="#4171E1" inactive-color="#000">
      <van-tabbar-item name="home" icon="wap-home-o" :disabled="true" @click="clickMenu(1)">首页</van-tabbar-item>
      <van-tabbar-item name="user" icon="contact" @click="clickMenu(2)">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {Dialog} from 'vant'

export default {
  name: 'App',
  data () {
    return {
      active: 'home',
      is_home: true
    }
  },
  watch: {
    active (val) {
      this.active = val
    }
  },
  created () {
    // localStorage.setItem('qrcode_id', '')
  },
  beforeUpdate () {
    this.active = this.$route.meta.active
    this.is_home = this.active === 'home'
  },
  methods: {
    clickHome () {
      window.location.href = this.$route.meta.homeUrl
    },
    clickMenu (type) {
      localStorage.setItem('is_home', this.is_home)
      if (type + '' === '1' && !this.is_home) {
        this.is_home = true
        this.$router.push({path: '/home', query: {qrcode_id: localStorage.getItem('qrcode_id')}})
      } else if (type + '' === '2' && this.is_home) {
        this.is_home = false
        localStorage.setItem('qrcode_id', this.$route.query.qrcode_id)
        this.$router.push('/user')
      }
    },
    clickLeft () {
      Dialog.confirm({
        message: '是否返回',
        beforeClose: (action, done) => {
          if (action === 'confirm') {
            this.$router.go(-1)
            done()
          } else {
            done()
          }
        }
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

.main{
  margin-top: 5px;
}
.color-w{
  color: #ffffff;
}
.justify-c{
  justify-content: center;
}
.align-c{
  align-items: center;
}
.align-s{
  align-items: flex-start;
}
.align-e{
  align-items: flex-end;
}
.flex-r{
  display: flex;
  flex-direction: row;
}
.flex-c{
  display: flex;
  flex-direction: column;
}
.flex1{
  flex: 1;
}
.flex2{
  flex: 2;
}
.flex3{
  flex: 3;
}
.flex4{
  flex: 4;
}

.fs12{
  font-size: 12px;
}
.fs14{
  font-size: 14px;
}
.fs16{
  font-size: 16px;
}
.fs18{
  font-size: 18px;
}
.fs20{
  font-size: 20px;
}
.fs22{
  font-size: 22px;
}
.fs24{
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue